import styled from 'styled-components';
import Image from 'next/image';

export const CampaignImgWrapper = styled.div`
  position: relative;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;
export const StyledImage = styled(Image)`
  width: 100% !important;
  height: 100% !important;
  z-index: -1;
`;
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  cursor: pointer;
  *,
  :after,
  :before {
    box-sizing: border-box;
    border-radius: 8px;
  }
`;
export const ImageWrapper = styled.div`
  background-image: linear-gradient(
    to bottom,
    rgba(108, 108, 108, 0),
    ${({ theme }) => theme.palette.eclipse}
  );
  position: relative;
  height: 100%;
`;

export const ImageContainer = styled.div<{ opacity?: number }>`
  width: auto;
  height: 324px;
  transition: all 0.35s;
  opacity: ${({ opacity }) => (opacity ? `${opacity}` : '1')};
  z-index: 44444;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    height: 200px;
  }
  .image {
    width: 100%;
    position: relative !important;
    object-fit: cover;
  }
`;
export const Img = styled(Image)<{ opacity?: number }>`
  transition: all 0.35s;
  opacity: ${({ opacity }) => (opacity ? `${opacity}` : '1')};
  z-index: 44444;
`;
export const Title = styled.span`
  font-size: 24px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  line-height: 1.17;
  display: block;
`;
export const Description = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.white};
`;

export const LogoWrapper = styled.div`
  max-width: 73px;

  & img {
    filter: none !important;
  }
`;

export const Marker = styled.div`
  width: 6px;
  height: 36px;
  background-color: ${({ theme }) => theme.palette.coral};
`;

export const ContentWrapper = styled.div`
  position: absolute;
  left: 20px;
  bottom: 20px;
  z-index: 20;
`;

export const FlexWrapper = styled.div`
  display: flex;
`;
